import { AgentDetails } from '@rma/public/compare-agent/private-api/da-compare-agent';
import { ProfileTheme } from '@rma/public/generic/domain/types';
import { CompareTile } from '../domain/compare-tile';

/**
 * Flattens a shortlisted agent into the tile the tray renders.
 *
 * Brand resolution runs three rungs: the agent's own logo, else the agency's, else a bare headshot.
 *
 * The agency rung is intentional and product-approved. `rma-api` blanks `Theme` when an agent's
 * subscription carries no branding entitlement, so falling through to the agency knowingly shows
 * branding that agent has not paid for. Honouring that gate is an `rma-api` mapping change, not a
 * client-side revert of this function.
 */
export function toCompareTile(agent: AgentDetails, agencyTheme?: ProfileTheme): CompareTile {
  const brand = resolveBrand(agent, agencyTheme);

  return {
    agentCode: agent.agentCode,
    agentName: agent.agentName,
    avatarImage: agent.theme?.avatarImage,
    logoUrl: brand?.rectangleLogoImage,
    primaryColour: brand?.primaryColour,
  };
}

// A theme with no rectangle logo cannot brand a tile, so it does not stop the fall-through.
function resolveBrand(agent: AgentDetails, agencyTheme?: ProfileTheme): ProfileTheme | undefined {
  if (agent.theme?.rectangleLogoImage) {
    return agent.theme;
  }

  if (agencyTheme?.rectangleLogoImage) {
    return agencyTheme;
  }

  return undefined;
}
